import React, { useState } from 'react';

const InstitutionLogo = ({ src, alt, fallback }) => {
    const [failed, setFailed] = useState(false);

    if (failed) {
        return (
            <div className="education-entry__logo-wrap education-entry__logo-wrap--fallback" aria-hidden>
                <span className="education-entry__logo-fallback">{fallback}</span>
            </div>
        );
    }

    return (
        <div className="education-entry__logo-wrap">
            <img
                className="education-entry__logo"
                src={src}
                alt={alt}
                width={160}
                height={100}
                onError={() => setFailed(true)}
            />
        </div>
    );
};

export default InstitutionLogo;
